import {IGlobalStore} from 'modules/types';

export const getFilters = ( state: IGlobalStore ) => state.filters;
